import api from './api';

export const authService = {
  login: (email, password) =>
    api.post('/auth/login/', { email, password }),

  register: (userData) =>
    api.post('/auth/register/', userData),

  googleSignIn: (token) =>
    api.post('/auth/google-signin/', { token }),

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('lyrapos_user');
  },

  getCurrentUser: () =>
    api.get('/auth/me/'),

  refreshToken: () =>
    api.post('/auth/token/refresh/'),
};
